import { render, staticRenderFns } from "./EnderecoFields.vue?vue&type=template&id=6215bfbb&"
import script from "./EnderecoFields.vue?vue&type=script&lang=js&"
export * from "./EnderecoFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports